/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { TasksApiConfiguration as __Configuration } from '../tasks-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultTaskGroupInfo } from '../models/list-query-result-task-group-info';
import { CreateTaskGroupCommand } from '../models/create-task-group-command';
import { UpdateTaskGroupCommand } from '../models/update-task-group-command';
import { AddRoleToTaskGroupCommand } from '../models/add-role-to-task-group-command';
@Injectable({
  providedIn: 'root',
})
class TaskGroupService extends __BaseService {
  static readonly GetAllPath = '/api/tasks/groups';
  static readonly CreateTaskGroupPath = '/api/tasks/groups';
  static readonly GetUpdateTaskGroupPath = '/api/tasks/groups/{id}/update';
  static readonly UpdateTaskGroupPath = '/api/tasks/groups/{id}/update';
  static readonly AddTaskGroupRolePath = '/api/tasks/groups/{id}/roles';
  static readonly DeleteTaskGroupRolePath = '/api/tasks/groups/{id}/roles/{roleId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `TaskGroupService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAllResponse(params: TaskGroupService.GetAllParams): __Observable<__StrictHttpResponse<ListQueryResultTaskGroupInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/groups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultTaskGroupInfo>;
      })
    );
  }
  /**
   * @param params The `TaskGroupService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAll(params: TaskGroupService.GetAllParams): __Observable<ListQueryResultTaskGroupInfo> {
    return this.GetAllResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultTaskGroupInfo)
    );
  }

  /**
   * @param command undefined
   */
  CreateTaskGroupResponse(command?: CreateTaskGroupCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/tasks/groups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  CreateTaskGroup(command?: CreateTaskGroupCommand): __Observable<null> {
    return this.CreateTaskGroupResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateTaskGroupResponse(id: string): __Observable<__StrictHttpResponse<UpdateTaskGroupCommand>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/groups/${id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UpdateTaskGroupCommand>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateTaskGroup(id: string): __Observable<UpdateTaskGroupCommand> {
    return this.GetUpdateTaskGroupResponse(id).pipe(
      __map(_r => _r.body as UpdateTaskGroupCommand)
    );
  }

  /**
   * @param params The `TaskGroupService.UpdateTaskGroupParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateTaskGroupResponse(params: TaskGroupService.UpdateTaskGroupParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/tasks/groups/${params.id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `TaskGroupService.UpdateTaskGroupParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateTaskGroup(params: TaskGroupService.UpdateTaskGroupParams): __Observable<null> {
    return this.UpdateTaskGroupResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `TaskGroupService.AddTaskGroupRoleParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  AddTaskGroupRoleResponse(params: TaskGroupService.AddTaskGroupRoleParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/tasks/groups/${params.id}/roles`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `TaskGroupService.AddTaskGroupRoleParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  AddTaskGroupRole(params: TaskGroupService.AddTaskGroupRoleParams): __Observable<null> {
    return this.AddTaskGroupRoleResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

    /**
   * @param params The `TaskGroupService.DeleteTaskGroupParams` containing the following parameters:
   *
   * - `id`:
   */
  DeleteTaskGroupResponse(params: TaskGroupService.DeleteTaskGroupParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/tasks/groups/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `TaskGroupService.DeleteTaskGroupParams` containing the following parameters:
   *
   * - `id`:
   */
  DeleteTaskGroup(params: TaskGroupService.DeleteTaskGroupParams): __Observable<null> {
    return this.DeleteTaskGroupResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `TaskGroupService.DeleteTaskGroupRoleParams` containing the following parameters:
   *
   * - `roleId`:
   *
   * - `id`:
   */
  DeleteTaskGroupRoleResponse(params: TaskGroupService.DeleteTaskGroupRoleParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/tasks/groups/${params.id}/roles/${params.roleId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `TaskGroupService.DeleteTaskGroupRoleParams` containing the following parameters:
   *
   * - `roleId`:
   *
   * - `id`:
   */
  DeleteTaskGroupRole(params: TaskGroupService.DeleteTaskGroupRoleParams): __Observable<null> {
    return this.DeleteTaskGroupRoleResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module TaskGroupService {

  /**
   * Parameters for GetAll
   */
  export interface GetAllParams {
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for UpdateTaskGroup
   */
  export interface UpdateTaskGroupParams {
    id: string;
    command?: UpdateTaskGroupCommand;
  }

  /**
   * Parameters for AddTaskGroupRole
   */
  export interface AddTaskGroupRoleParams {
    id: string;
    command?: AddRoleToTaskGroupCommand;
  }

  /**
   * Parameters for DeleteTaskGroup
   */
  export interface DeleteTaskGroupParams {
    id: string;
  }
  /**
   * Parameters for DeleteTaskGroupRole
   */
  export interface DeleteTaskGroupRoleParams {
    roleId: string;
    id: string;
  }
}

export { TaskGroupService }
